<template>
  <Card>
    <router-link class="mb-2 btn btn-info" to="/Manager/Add">افزودن مدیر جدید</router-link>
    <LocalDataTable :ajax-link="ajaxLink" :columns="columns"></LocalDataTable>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import LocalDataTable from "@/components/LocalDataTable";
import {mapActions} from "vuex";
export default {
name: "ManagerList",
  components: {LocalDataTable, Card},
  data()
  {
    return{
      ajaxLink : 'admin/Manager/List',
      columns : [
          {title : 'نام کامل'},{title : 'تلفن'},{title : 'نام کاربری'},{title : 'نقش'},{title : '<i class="far fa-edit"></i>'}
          ],
    }
  },
  mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('مدیریت مدیران سیستم');
    this.setShowHead(true);
  },
  methods :{
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>